<template>
  <div class="item-preview">    

    <!-- image -->
    <div class="item-preview-image" :class="['item-big', !!showActionsOnDevices ? 'active' : '']">      
      <div class="inner-bg" :style="imageStyle">
      </div>
    </div>

    <!-- lables ShortName-->
    <div class="label" >
      <span class="item-mac text--s" v-html="item.CatalogNo"></span><br/>
      <span class="item-name font-rg" v-html="item.ShortName"></span>
      <template v-if="specs">
        <span v-for="specsItem in specs" class="specrow text--s" :key="specsItem">
          {{specsItem}}
        </span>
      </template>
    </div>    

  </div>
</template>

<script>
export default {
  props: ["type", "info", "item", "size", "actions", "draggable","removable","specs"],
  created() {
  },
  data() {
    return {
      thumbURL: null,
      addingFav: false,
      hasBeenFaved: false,
      removingFav: false,
      favTransform: false,
      showActionsOnDevices: false,
      btnClickDisabler: false,
      inSwipeScroll: false
      // translate
    };

  },
  methods: {
    toggleActionsForDevices(e) {
      if (e.type === "touchmove") {
        this.$set(this, "inSwipeScroll", true);
      } else {
        if (!this.inSwipeScroll) {
          if (this.isTouchDevice) {
            setTimeout(
              function() {
                this.showActionsOnDevices = !this.showActionsOnDevices;
              }.bind(this),
              100
            );
          }
        }
        this.$set(this, "inSwipeScroll", false);
      }
    },
    parsePlatform(platform, label) {
      // console.log("parseplatform >> ", platform, " :: ", label);
      if (platform.indexOf("Standard") > -1) {
        return label ? "SP" : "item-platform--sp";
      } else if (platform.indexOf("Wide") > -1) {
        return label ? "WP" : "item-platform--wp";
      } else if (platform.indexOf("Narrow") > -1) {
        return label ? "NP" : "item-platform--np";
      }
    },        
  },
  asyncComputed: {
    previewImageStyle() {
      let vm = this;
      vm.thumbURL = "https://www.mis-implants.com/upload/catalog/products/large/MK-CD01.png";
      return resolve(`background-image:url(${vm.thumbURL})`);
      /*
      return new Promise(resolve => {
        let img = document.createElement("img");
        img.addEventListener("load", function() {
          resolve(`background-image:url(${vm.thumbURL})`);
        });
        img.addEventListener("error", function() {
          resolve("background:black");
        });
        img.src = vm.thumbURL;//vm.item.image;
      });*/

    }
  },
  computed: {
    imageStyle() {
      //:style="imageStyle"
      var url  = "https://www.mis-implants.com/upload/catalog/products/large/"+
                this.item.CatalogNo+".png";
      return "background-image:url("+url+")";
    },
    isTouchDevice() {
      return true;
    },
    isIOSDevice() {
      return /iPad|iPhone|iPod/.test(window.navigator.platform);
    }
  }  
};
</script>



<style scoped>
  .item-preview
  {
    width: 100%;
    height: 10vw;
    float: left;
    
  }
  .item-preview-image
  {
    position: relative;
    width: 100%;
    height: 100%;
    display: block;
    background-color: #f9f9f9;
    padding: 30px;
  }
  .inner-bg
  {
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center center;
      background-color:#f9f9f9;
      width: 100%;
      height: 100%;
  }
  .label
  {
    clear: both;
    padding-top: 5px;
    text-align: left;
    white-space:initial;
  }
  .item-mac
  {
    color:#5e5e5e !important;
    line-height: 1.2;
  }
  .item-name
  {
    color:#2d2d2d !important;
    font-size: 13px;
  }
  .specrow
  {
    display: block;
    color: #5e5e5e;
    line-height: 1.2;
    font-size: 13px;
  }

  @media screen and (max-width:900px) {
    .item-preview {
        height: 33vw;
    }  
  }



</style>

